import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import Flag from './main';
var FlagWithEvents = withEvents(Flag);
export { Flag, FlagWithEvents };
export default withMessage(FlagWithEvents, 'flag');